import { AccessListValues } from '../permitsList';
import { INavItem } from '../interfaces';

export function createNavItems(dataState: {
  allowViewHistorySam?: boolean;
  allowViewHistoryUser?: boolean;
}): INavItem[] {
  return [
    {
      to: '/inventario',
      label: 'Inventario',
      permit: AccessListValues.SAM_INVENTORY_LIST,
      isParent: true,
      items: [],
      icon: '',
      parent: '/inventario',
    },
    {
      to: '/reassignment',
      label: 'Reasignación',
      permit: AccessListValues.OP_REASSIGN_SAM_LIST,
      isParent: true,
      items: [],
      icon: '',
      parent: '/reassignment',
    },
    {
      to: '/history',
      label: 'Historiales',
      permit: AccessListValues.HISTORY_GENERAL,
      condition: dataState?.allowViewHistorySam,
      isParent: true,
      icon: '',
      parent: '/history',
      items: [
        {
          to: '/history-sam',
          label: 'SAM',
          permit: AccessListValues.HISTORY_GENERAL,
          condition: dataState?.allowViewHistorySam,
          items: [],
          isParent: false,
          parent: '/history',
          icon: 'samIcon',
        },
        {
          to: '/history-cards',
          label: 'Tarjetas',
          permit: AccessListValues.HISTORY_GENERAL,
          condition: dataState?.allowViewHistorySam,
          items: [],
          parent: '/history',
          isParent: false,
          icon: 'cardIcon',
        },
        {
          to: '/history-user',
          label: 'Usuario',
          permit: AccessListValues.HISTORY_USERS,
          condition: dataState?.allowViewHistoryUser,
          items: [],
          isParent: false,
          parent: '/history',
          icon: 'userIcon',
        },
        {
          to: '/history-device',
          label: 'Dispositivos',
          permit: AccessListValues.HISTORY_GENERAL,
          condition: dataState?.allowViewHistorySam,
          items: [],
          isParent: false,
          parent: '/history',
          icon: 'deviceIcon',
        },
      ],
    },

    {
      to: '/catalogos',
      label: 'Catálogos',
      permit: AccessListValues.CATALOGS_LIST,
      items: [],
      isParent: true,
      icon: '',
      parent: '/catalogos',
    },
    {
      to: '/administrar-usuarios',
      label: 'Usuarios',
      permit: AccessListValues.SEC_USERS_LIST,
      items: [],
      isParent: true,
      icon: '',
      parent: '/administrar-usuarios',
    },
    {
      to: '/roles',
      label: 'Roles',
      isParent: true,
      permit: AccessListValues.SEC_ROLE_LIST,
      items: [],
      icon: '',
      parent: '/roles',
    },
    {
      to: '/sandbox',
      label: 'Sandbox',
      isParent: true,
      permit: AccessListValues.SANDBOX_LIST,
      items: [],
      icon: '',
      parent: '/sandbox',
    },
  ];
}
